import type { HttpMethod } from "@serophin/shared";
import { ContractBuilder } from "@serophin/shared";

/** The version in the path of this app's own endpoints. `/api/v1` is the old mobile API (web/src/api/legacy); `/api/auth/*` and `/api/health` are unversioned. */
export const API_VERSION = "v2";

export const apiV2 = (method: HttpMethod, path: string): ContractBuilder => new ContractBuilder(method, `/api/${API_VERSION}${path}`);
